import {CorrespondantDto, IdsDto, NotificationModuleDto} from "./../../common/resources/resources";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {Component} from "@angular/core";
import {IAuditWebServiceClient, INotificationsCommonWebServiceClient} from "@common/resources/resources";
import {CerbaCookieService, CookieConstantes, CorrespondantStore, UserStore, PopinCompteComponent, ProfilValideDto, NotificationService} from "@digicerba/common";
import {TranslateService} from "@ngx-translate/core";
import * as lodash from "lodash";
import { AsiDialogService } from "@asi-ngtools/lib";
import { NotificationModuleComponent } from "./modal-notification-module/notification-module.component";
import {DetectBrowser} from "@common/browser/detect-browser";

@Component({
  selector: 'cerba',
  templateUrl: './cerba.component.html',
  host: {'class': 'flex'}
})
export class CerbaPageComponent {

  context: any;

  constructor(private router: Router, private auditWebServiceClient: IAuditWebServiceClient,
              private activatedRoute: ActivatedRoute,
              private correspondantStore: CorrespondantStore,
              private cookieService: CerbaCookieService,
              private userStore: UserStore,
              private notificationService: INotificationsCommonWebServiceClient,
              private translate: TranslateService,
              public asiDialogService: AsiDialogService,
              private toasterService : NotificationService) {


    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.auditWebServiceClient.info({url: event.url}).subscribe(() => {
        });
      }
    });
  }

  ngOnInit() {
    let correspondants: Array<CorrespondantDto> = this.correspondantStore.getCorrespondants();
    var cookieValue = this.cookieService.getCoockieValue(CookieConstantes.COOKIE_CORRESPONDANT);
    if (cookieValue) {
      let selectedCorrespndant = correspondants.find(correspondant => correspondant.code === cookieValue);
      this.correspondantStore.setCorrespondant(selectedCorrespndant);
    } else {
      this.correspondantStore.setCorrespondant(correspondants[0]);
    }
    let selectedValue = this.correspondantStore.getCorrespondant();

    let tags: string[] = [];
    this.correspondantStore.getCorrespondants().forEach(c => {
      tags = tags.concat(c.tags)
    })
    tags = lodash.uniq(tags);

    if (tags.indexOf("en") != -1 && tags.indexOf("fr") == -1) {
      this.translate.use('en');
    }
    else {
      this.translate.use('fr');
    }

    let currentTags: string[] = [];
    if (this.correspondantStore.getCorrespondant()) {
      currentTags = this.correspondantStore.getCorrespondant().tags;
    }

    let profilValideDto: ProfilValideDto = this.activatedRoute.snapshot.data['profilValide'];

    this.context = {
      user: this.userStore.getUser(),
      domain: this.cookieService.getDomain(window.location.hostname),
      supportBaseUrl: this.cookieService.getSupportBaseUrl(window.location.hostname),
      nbAlerts: this.activatedRoute.snapshot.data['nbAlerts'],
      // Ajout des tags pour la gestion dynamique des outils du header et footer
      tags: currentTags,
      // Ajout de la gestion de la validité des iformations utilisateurs
      profilValide: profilValideDto,
      openPopin: this.openPopinCompte,
      component: this
    };
    if(profilValideDto.autoDisplayPopin){
      this.openPopinCompte(this);
    }

    var notifications:NotificationModuleDto[] = this.activatedRoute.snapshot.data['notifmodule'];

    if(notifications.length > 0){
      let asiDialog = this.asiDialogService.fromComponent(NotificationModuleComponent, null);
      asiDialog.onDialogClose().subscribe(() => {
        let ids: number[] = [];
        for(var i = 0; i < notifications.length; i++){
          ids.push(notifications[i].id);
        }
        let idsDto: IdsDto = {ids : ids};
        this.notificationService.markAsReadMessageNotifications(idsDto).subscribe(
          _ => {} , err => {
            this.toasterService.showErrorNotification('Une erreur est survenue lors de la lecture des message de notification');
            console.error(err);
          }
        );
       });

      asiDialog.getComponent().notifications = notifications;
      asiDialog.getComponent().notification = notifications[0];
      asiDialog.getComponent().index = 0;
    }

  };

  openPopinCompte(component: CerbaPageComponent): void{
    let asiDialog = component.asiDialogService.fromComponent(PopinCompteComponent, null);
    let profilValideDto: ProfilValideDto = component.activatedRoute.snapshot.data['profilValide'];
    asiDialog.getComponent().formattedDate = profilValideDto.dateLimite;
  }


  isInternetExplorer(): boolean {
    return DetectBrowser.isInternetExplorer();
  }
}




// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/cerba.component.ts